(function () {
  "use strict";

  function initVSAboutFounder(section) {
    if (!section) {
      return;
    }

    if (section.dataset.vsInitialized === "true") {
      return;
    }

    section.dataset.vsInitialized = "true";

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries, observerInstance) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add(
              "vs-about-founder--visible"
            );

            observerInstance.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: "0px 0px -30px 0px"
        }
      );

      observer.observe(section);
    } else {
      section.classList.add(
        "vs-about-founder--visible"
      );
    }

    var socialCards = section.querySelectorAll(
      ".vs-about-founder__social-card"
    );

    socialCards.forEach(function (card, index) {
      card.style.setProperty(
        "--vs-social-index",
        index
      );
    });
  }

  function initAll(root) {
    var scope = root || document;

    var sections = scope.querySelectorAll(
      ".vs-about-founder"
    );

    sections.forEach(function (section) {
      initVSAboutFounder(section);
    });
  }

  document.addEventListener(
    "DOMContentLoaded",
    function () {
      initAll(document);
    }
  );

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initAll(event.target);
    }
  );

  document.addEventListener(
    "shopify:section:reorder",
    function () {
      initAll(document);
    }
  );

  document.addEventListener(
    "shopify:section:select",
    function (event) {
      initAll(event.target);
    }
  );

  document.addEventListener(
    "shopify:block:select",
    function (event) {
      var section = event.target.closest(
        ".vs-about-founder"
      );

      if (section) {
        initVSAboutFounder(section);
      }
    }
  );
})();